var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.726 1.74c-2.468 0-4.5 2.032-4.5 4.5v30c0 2.468 2.032 4.5 4.5 4.5h16.5v-24h15v9.375h3V6.24c0-2.468-2.033-4.5-4.5-4.5h-30Zm0 3h13.5v9h-15v-7.5c0-.844.655-1.5 1.5-1.5Zm16.5 0h13.5c.844 0 1.5.656 1.5 1.5v7.5h-15v-9Zm-18 12h15v9h-15v-9Zm0 12h15v9h-13.5a1.48 1.48 0 0 1-1.5-1.5v-7.5Zm26.56.44-2.121 2.12 6.44 6.44-6.44 6.44 2.121 2.12 6.44-6.439 6.439 6.44 2.121-2.122-6.44-6.439 6.44-6.44-2.121-2.12-6.44 6.439-6.439-6.44Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export default ForwardRef;